module.exports = __webpack_public_path__ + "static/media/PATS_3-634w.7f8dc57f.png";